// extracted by mini-css-extract-plugin
export default {"picture":"image_picture__52Le0","img":"image_img__P5eJL","radiusSmall":"image_radiusSmall__EKdKz","squared":"image_squared__xEavr"};